
export default () => {
    $('a[href$="/logout"]').on("click", () => {
        window.spinner.show();
    })
}
